/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $EventLineChart = {
    properties: {
        labels: {
    type: 'array',
    contains: {
    type: 'string',
},
},
        data: {
    type: 'array',
    contains: {
        type: 'Dataset',
    },
},
    },
};